import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    maxWidth: "1000px",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
    padding: theme.spacing(3, 0),

    "@media (max-width: 768px)": {
      width: "95%",
      padding: theme.spacing(2, 0),
    },
  },

  content: {
    flexGrow: 1,
    overflowY: "auto",
    padding: theme.spacing(1, 2, 4),

    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#d4d4d4",
      borderRadius: 6,
    },
  },

  title: {
    fontSize: 32,
    fontWeight: 700,
    color: "#15254F",
    marginBottom: theme.spacing(3),
    textAlign: "center",

    "@media (max-width: 600px)": {
      fontSize: 26,
    },
  },

  section: {
    marginBottom: theme.spacing(4),
  },

  heading: {
    fontSize: 20,
    fontWeight: 600,
    color: "#15254F",
    marginBottom: theme.spacing(1.5),
    borderLeft: "4px solid #1CB167",
    paddingLeft: theme.spacing(1.5),
  },

  paragraph: {
    fontSize: 15,
    lineHeight: 1.8,
    color: "#555",
    marginBottom: theme.spacing(2),
  },

  list: {
    margin: 0,
    paddingLeft: theme.spacing(3),

    "& li": {
      fontSize: 15,
      lineHeight: 1.8,
      color: "#555",
      marginBottom: theme.spacing(1),
    },
  },

  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
    borderTop: "1px solid #E5E5E5",
    zIndex: 10,
  },

  nextButton: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0 40px",
    height: 50,
    minWidth: 140,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",

    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },

    "&:focus": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },

    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },
  table: {
    width: "100%",
    minWidth: "700px",
    borderCollapse: "collapse",

    "& th, & td": {
      border: "1px solid #ccc",
      padding: "12px",
      textAlign: "left",
      verticalAlign: "top",
    },

    "& thead th": {
      backgroundColor: "#1CB167",
      color: "#fff",
      fontWeight: 600,
    },

    "& tbody tr:nth-child(even)": {
      backgroundColor: "#f8f9fa",
    },

    "& ul": {
      margin: "8px 0 0",
      paddingLeft: "18px",
    },

    "& strong": {
      fontWeight: "bold",
    },
  },
}));
const PrivacyPolicy = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1 className={classes.title}>Privacy Policy</h1>
      <p>
        This Privacy Policy (<strong style={{fontWeight:"bold"}}>&quot;Privacy Policy&quot;</strong>) has
        been prepared by Aryaman Finance (India) Limited (
        <strong style={{fontWeight:"bold"}}>&quot;GetCred&quot;</strong>, <strong style={{fontWeight:"bold"}}>&quot;We&quot;</strong>,{" "}
        <strong style={{fontWeight:"bold"}}>&quot;Our&quot;</strong>, <strong style={{fontWeight:"bold"}}>&quot;Us&quot;</strong>), a
        public company incorporated in India (CIN
        U64910MH2025PLC439433), having its branch office at 105, First Floor, Barodia Tower, D-Block, Central market, Prashant Vihar, Rohini, Delhi-110085, India. We understand privacy and its value. Therefore, it is all the
        more important for us to make YOU (<strong style={{fontWeight:"bold"}}>&quot;You&quot;</strong>,{" "}
        <strong style={{fontWeight:"bold"}}>&quot;Customer&quot;</strong> or{" "}
        <strong style={{fontWeight:"bold"}}>&quot;User&quot;</strong>), the user of the website{" "}
        <a
          href="https://pls.getcred.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://pls.getcred.in/
        </a>{" "}
        (the <strong style={{fontWeight:"bold"}}>&quot;Website&quot;</strong>) and its associated mobile
        application, GetCred (the <strong style={{fontWeight:"bold"}}>&quot;Application&quot;</strong>)
        (collectively, the <strong style={{fontWeight:"bold"}}>&quot;Platform&quot;</strong>) understand the
        reason behind the collection of all types of your information or data (
        <strong style={{fontWeight:"bold"}}>&quot;Information&quot;</strong>) and its usage and the manner
        in which we collect, use, store, and share your information. This
        Privacy Policy has been prepared in compliance with:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>A.</strong> Information Technology Act, 2000 (
          <strong style={{fontWeight:"bold"}}>&quot;IT Act&quot;</strong>) and corresponding rules as may be
          notified from time to time, including Information Technology
          (Reasonable Security Practices and Procedures and Sensitive Personal
          Data or Information) Rules, 2011 and Information Technology
          (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021;
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>B.</strong> Digital Personal Data Protection Act, 2023 (
          <strong style={{fontWeight:"bold"}}>&quot;DPDPA&quot;</strong>) and corresponding rules as may be
          notified from time to time;
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>C.</strong> Reserve Bank of India (Non-Banking Financial
          Companies–Credit Facilities) Directions, 2025; and
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>D.</strong> Other applicable acts, regulations and rules which
          require the publishing of a privacy policy for handling of or dealing
          in personal Information including sensitive personal data or
          Information and all applicable laws, regulations, directions,
          guidelines provided by applicable regulatory authorities, including
          but not limited to the Reserve Bank of India (
          <strong style={{fontWeight:"bold"}}>&quot;RBI&quot;</strong>).
        </li>
      </ul>
      <p>
        This Privacy Policy is incorporated into and at all times is subject to
        and is to be read in conjunction with the Terms of Use of the Platform.
      </p>
      <p>
        The Privacy Policy summarises all types of Information that is collected
        from You by Us, the manner in which it is shared by Us with other third
        parties as detailed under this Privacy Policy, along with the purpose of
        collection for each, whether provision of such Information is mandatory
        or optional for availing the services on the Platform, retention period
        and the parties that have access to and store such Information.
      </p>
      <p>
        Since the Platform provides (i) services in relation to facilitating the
        disbursement of lending products/loans offered by Lending Partners (as
        defined in Part-B below) (
        <strong style={{fontWeight:"bold"}}>&quot;Digital Lending Services&quot;</strong>); (ii) GetCred
        UPI Services; and (iii) digital gold and any and all other services that
        may be provided on the Platform from time to time (
        <strong style={{fontWeight:"bold"}}>&quot;Additional Services&quot;</strong>); and (collectively the{" "}
        <strong style={{fontWeight:"bold"}}>&quot;Services&quot;</strong>) to its Users, for the ease of
        reference, we have divided the Privacy Policy into five parts:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>Part A:</strong> Account Creation and Registration
        </li>
        <li>
          <strong style={{fontWeight:"bold"}}>Part B:</strong> Digital Lending Services
        </li>
        <li>
          <strong style={{fontWeight:"bold"}}>Part C:</strong> GetCred UPI Services
        </li>
        <li>
          <strong style={{fontWeight:"bold"}}>Part D:</strong> Additional Services
        </li>
        <li>
          <strong style={{fontWeight:"bold"}}>Part E:</strong> Miscellaneous Terms
        </li>
      </ul>
      <p>
        Please note, any Information collected from You is for the specific
        purpose(s) based on the nature of Services availed as per this Privacy
        Policy, and there is no cross-sharing or cross-collection of any such
        Information of the Users availing one of the Services for other Services
        that are not availed by them.
      </p>
      <p>
        In order to avail any Services being provided by GetCred by itself or
        in partnership with its service partners (as mentioned in the respective
        parts of this Privacy Policy), it is important that{" "}
        <strong style={{fontWeight:"bold"}}>
          YOU READ, UNDERSTAND, ACKNOWLEDGE AND UNCONDITIONALLY AGREE TO BE
          BOUND BY THE TERMS AND CONDITIONS OF THIS PRIVACY POLICY.
        </strong>
      </p>
      <p>
        For the Users consenting to continue accessing the Platform and avail
        the Service(s), this Privacy Policy explains our policies and practices
        regarding the collection, use, and disclosure of Your Information.
      </p>
      <section>
         <h2 className={classes.title}>
          PART A: ACCOUNT CREATION AND REGISTRATION
        </h2>
        <h3 className={classes.heading}>COLLECTION OF INFORMATION</h3>

        <p>
          <strong style={{fontWeight:"bold"}}>1.1.</strong> All Information collected on the Platform for
          creation of Your account and registration as a user on the Platform
          and general use of the Platform (
          <strong style={{fontWeight:"bold"}}>&quot;Profile Data&quot;</strong>) is done through the means
          of:
        </p>

        <ol>
          <li>
            <strong style={{fontWeight:"bold"}}>1.1.1.</strong> Your mobile and email address provided at
            the time of account creation on the Platform;
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>1.1.2.</strong> Consents (other than the consents as
            specified in Part-B to Part-D hereof, if any) that You provide when
            You register on or browse through the Website or the Application;
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>1.1.3.</strong> Data provided during communications with us
            (for example, by e-mail or chat) with respect to Your account;
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>1.1.4.</strong> Data generated by Your general usage of our
            Platform, and when You report a problem with our Platform.
          </li>
        </ol>
        <p>
          <strong style={{fontWeight:"bold"}}>1.2.</strong> Collection of other Non-Personal Information
        </p>

        <ol start={2}>
          <li>
            <strong style={{fontWeight:"bold"}}>1.2.1. Cookies:</strong> Cookies are small data files that
            the Website stores on Your computer. Use of this Information helps
            Us identify You in order to make our Website more user friendly. We
            do not store personal/identity Information in the cookies. You have
            the right to reject our access to Cookies since most browsers will
            permit You to decline cookies, but if You choose to do this it might
            affect service on some parts of Our Website.
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>1.2.2.</strong> If You choose to avail any Services through
            the Platform, we collect Information about the manner in which You
            are using the Platform. We retain this Information as necessary to
            resolve disputes, provide customer support, and troubleshoot
            problems as permitted by law. If You send us personal
            correspondence, such as emails or letters, or if other users or
            third parties send us correspondence about Your activities or
            postings on the Website, we collect such Information into a file
            specific to You.
          </li>
        </ol>
        <p>
          <strong style={{fontWeight:"bold"}}>1.3.</strong> Consents sought as part of rendering the
          Services (through the Website or Application)
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.3.1.</strong> Upon creation of Your account and registration
          on the Platform, we collect the following Information which is
          mandatorily required for the Application&apos;s functionality and
          performance. This access is enabled at the time You install the
          Application on Your mobile phone via Google Play Store and Apple Store
          or visit the Website.
        </p>
        <div className={classes.tableWrapper}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Data</th>
              <th>Purpose</th>
              <th>Mandatory / Optional</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1.</td>
              <td>
                <strong style={{fontWeight:"bold"}}>Personal Information</strong>
                <ul>
                  <li>Name</li>
                  <li>Mobile number</li>
                  <li>Email address</li>
                </ul>
              </td>
              <td>
                This Information is used for identifying You, preventing
                unauthorised access, providing the Services, registering and
                enabling You to use the Website and app functionality*.
              </td>
              <td>
                <strong style={{fontWeight:"bold"}}>Mobile number &amp; Email ID</strong> – Mandatory
                <br />
                <strong style={{fontWeight:"bold"}}>Name</strong> – Mandatory if any Service is availed
              </td>
            </tr>

            <tr>
              <td>2.</td>
              <td>
                <strong style={{fontWeight:"bold"}}>Device Information</strong>
                <br />
                Device IDs, log Information (search queries, IP address,
                crashes, date, etc.), browser details, device Information, usage
                Information, feedback and similar Information. The Information
                collected depends on how You manage Your privacy controls on
                Your device.
              </td>
              <td>
                Your log Information is collected for improving Platform
                functionality, identity verification, fraud prevention and app
                functionality*.
              </td>
              <td>Mandatory</td>
            </tr>

            <tr>
              <td>3.</td>
              <td>
                <strong style={{fontWeight:"bold"}}>Application Information</strong>
                <ul>
                  <li>Crash logs</li>
                  <li>Diagnostics</li>
                  <li>Other app performance data</li>
                </ul>
              </td>
              <td>
                Information related to the performance of the Platform and
                diagnostic data is collected for identifying and resolving
                technical glitches, data analytics and app functionality*.
              </td>
              <td>Mandatory</td>
            </tr>
          </tbody>
        </table>
        </div>
        <p>
          <strong style={{fontWeight:"bold"}}>*</strong> The term <strong style={{fontWeight:"bold"}}>app functionality</strong> means
          the Information collected for provision of any of the services on, and
          improving the overall performance of, the GetCred DLA.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.3.2.</strong> Please refer to the other Parts of this
          Privacy Policy for details on other accesses enabled via Google Play
          Store, Apple Store and the Website for the respective Services availed
          by You.
        </p>
        <p>
          <strong style={{fontWeight:"bold"}}>1.4.</strong> Consents sought for Profile Creation and
          Registration (through our Application)
        </p>
        <div className={classes.tableWrapper}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Nature of Consent Sought</th>
              <th>Purpose</th>
              <th>Mandatory / Optional</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>1.</td>
              <td>
                Your consent that You have read the terms of our Terms of Use /
                Terms &amp; Conditions and this Privacy Policy.
              </td>
              <td>
                Profile Creation and Registration
                <br />
                <strong style={{fontWeight:"bold"}}>Consent type:</strong> Recurring
              </td>
              <td>Mandatory</td>
            </tr>

            <tr>
              <td>2.</td>
              <td>Consent to access Your Google email Information.</td>
              <td>
                Identity verification, Sending communications
                <br />
                <strong style={{fontWeight:"bold"}}>Consent type:</strong> One-time
              </td>
              <td>Optional</td>
            </tr>

            <tr>
              <td>3.</td>
              <td>
                <strong style={{fontWeight:"bold"}}>Social Account Information</strong> – We may provide You
                with the option to register using social accounts (Google or
                Facebook) to access the app and shall collect only such
                registered email ID and user public profile Information like
                name, email, ASID depending on the platform used by You to log
                into the Website during the registration / sign-in process for
                the Services.
                <br />
                <br />
                We may collect and store the email ID and name associated with
                that account for the purpose of verification and to pre-populate
                relevant fields in the course of the Platform interface.
              </td>
              <td>
                Verification and pre-populating user details
                <br />
                <strong style={{fontWeight:"bold"}}>Consent type:</strong> One-time
              </td>
              <td>Optional</td>
            </tr>

            <tr>
              <td>4.</td>
              <td>
                Consent for sending promotional communication via SMS, Email and
                WhatsApp.
              </td>
              <td>
                Advertisement and Marketing
                <br />
                <strong style={{fontWeight:"bold"}}>Consent type:</strong> Recurring
              </td>
              <td>
                Mandatory at the time of registration (can be opted out later)
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        <p>
          <strong style={{fontWeight:"bold"}}>1.4.1.</strong> Please refer to other Parts of this Privacy
          Policy for details on other consents taken by the Application for the
          respective Services availed by You.
        </p>

        <h3 className={classes.heading}>PURPOSE OF COLLECTION</h3>

        <p>
          <strong style={{fontWeight:"bold"}}>2.1.</strong> We understand the importance of Your Information
          and, as a responsible company, we strive to ensure that it is used
          only for the intended purposes. We shall use the Information collected
          from You for facilitating the Services for the following purposes as
          detailed below.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>2.2.</strong> The intended purpose of collecting such
          Information provided by You is summarized below:
        </p>
        <div className={classes.tableWrapper}>
        <table className={classes.table}>
          <thead>
            <tr>
              <th>Used For</th>
              <th>Purpose</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <strong style={{fontWeight:"bold"}}>Account / Profile Creation and Registration</strong>
              </td>
              <td>
                Your Profile Data is collected to establish and verify Your
                identity, and to create and verify Your account.
              </td>
            </tr>

            <tr>
              <td>
                <strong style={{fontWeight:"bold"}}>For Enabling Customer Support</strong>
              </td>
              <td>
                We use Your mobile number and email ID (forming part of the
                Profile Data) to provide customer support, facilitate any
                request, customize Your experience, enforce our Terms and
                Conditions, and resolve concerns relating to Your account.
              </td>
            </tr>

            <tr>
              <td>
                <strong style={{fontWeight:"bold"}}>Data Analytics</strong>
              </td>
              <td>
                We may use the Profile Data collected to develop automated
                actions triggered by certain events. We may also use the
                Information collected to offer or recommend new products and
                services for Your use.
                <br />
                <br />
                We may further measure consumer interest and satisfaction in our
                products and services and manage Our relationship with You.
              </td>
            </tr>

            <tr>
              <td>
                <strong style={{fontWeight:"bold"}}>For Enabling Communications Between You and Us</strong>
              </td>
              <td>
                We may add features that enable communications between You and
                Us, and may access communications, notifications, Information
                regarding the products or services requested by You, process
                queries and applications submitted on the Application, or
                communicate regarding transactions, promotional activities,
                marketing and commercial communications.
                <br />
                <br />
                We may also disclose Information where required under applicable
                law, court summons, court orders, or requests/orders from legal
                authorities or law enforcement agencies.
              </td>
            </tr>

            <tr>
              <td>
                <strong style={{fontWeight:"bold"}}>For Legal Compliance and Requirements</strong>
              </td>
              <td>
                We use the Profile Data to detect and protect against suspicious
                or illegal activity, fraud, money laundering and other criminal
                activity, investigate or prevent illegal activities, conduct
                forensic audits, address claims or disputes relating to Your
                account, comply with applicable laws, or respond to requests
                from regulators, government entities and official authorities.
              </td>
            </tr>

            <tr>
              <td>
                <strong style={{fontWeight:"bold"}}>Advertising, Branding and Marketing</strong>
              </td>
              <td>
                We may use the Profile Data collected to market different
                products and Services available on the Application. This
                includes sharing Your feedback, ratings and screen names for
                promotional and marketing purposes. We may contact You through
                email, telephone, SMS, WhatsApp, messages or other available
                communication channels regarding offers, products, services and
                updates.
              </td>
            </tr>
          </tbody>
        </table>
        </div>
        <h3 className={classes.heading}>STORAGE OF PERSONAL INFORMATION</h3>

        <p>
          <strong style={{fontWeight:"bold"}}>3.1.</strong> We ensure that all Information collected by us
          from You under this Part A, including Your mobile number and email
          address, is stored on servers located within India. For account
          creation and registration purposes, we ensure that no other personal
          Information belonging to You is collected by us. In case any of our
          representatives ask for the same from You, we request that You kindly
          refrain from sharing such Information and report this concern to our
          Grievance Officer (the details of the same have been provided below).
        </p>

        <h3 className={classes.heading}>DISCLOSURE TO THIRD PARTIES</h3>

        <p>
          <strong style={{fontWeight:"bold"}}>4.1.</strong> We will share Your Profile Data only on a need
          basis with the governmental/regulatory authorities, courts,
          regulators, law enforcement agencies, quasi-governmental authorities,
          judicial authorities and quasi-judicial authorities (
          <strong style={{fontWeight:"bold"}}>&quot;Governmental Agencies&quot;</strong>) if any Information
          is requested from us and we believe that such disclosure is required
          or appropriate in order to comply with applicable laws, regulations or
          legal processes. We may share Your Profile Data, as required, upon
          receipt of any notice, communication or order as part of Our legal
          obligations under applicable laws. By accepting this Privacy Policy,
          You hereby provide Your consent to disclose Your personal Information
          for such regulatory disclosure.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>4.2.</strong> Further, Your Profile Data will also be shared
          with Lending Partners and Additional Service Partners (
          <strong style={{fontWeight:"bold"}}>&quot;Platform Partners&quot;</strong>), strictly based on the
          nature of the Services availed by You, and in accordance with the
          policy set out in the respective Part of this Privacy Policy, as
          applicable.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>4.3.</strong> We will share Your Information under a
          confidentiality agreement with these Platform Partners and restrict
          the use of such Information by these Platform Partners solely for the
          purposes detailed hereinabove.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>4.4.</strong> Any disclosure to the Platform Partners is
          subject to the following:
        </p>

        <ul>
          <li>
            <strong style={{fontWeight:"bold"}}>4.4.1.</strong> If we are under a duty to disclose or share
            Your personal Information in order to comply with any legal or
            regulatory obligation or request, we shall not seek Your explicit
            consent nor notify the same to You.
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>4.4.2.</strong> We shall share Your Information with third
            parties only on a need basis and only for the purposes stated
            herein, in accordance with applicable laws.
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>4.4.3.</strong> We shall additionally seek explicit consent
            at appropriate stages of Information collection, if so required
            under applicable laws.
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>4.4.4.</strong> Usage of Your Information by such Platform
            Partners is subject to their respective privacy policies. We share
            Information with them only to the extent required. We recommend that
            You review the privacy policies of such Platform Partners.
          </li>
        </ul>
        <h3 className={classes.heading}>DATA RETENTION AND DELETION</h3>

        <p>
          <strong style={{fontWeight:"bold"}}>5.1.</strong> We retain Your Profile Data to provide a
          seamless experience, to contact You in case support is required or
          regarding Your account, and to detect, mitigate, prevent, and
          investigate fraudulent or illegal activities during the course of the
          Services.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>5.2.</strong> We retain Your Profile Data from the date of
          creation of Your account on the Platform:
        </p>

        <ul>
          <li>
            <strong style={{fontWeight:"bold"}}>(a)</strong> For a period of <strong style={{fontWeight:"bold"}}>6 (six) years</strong>{" "}
            from the last date of submission of Information or inactivity
            (whichever is later) if You have registered on the Application but
            have not availed any Services.
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>(b)</strong> For a period of <strong style={{fontWeight:"bold"}}>10 (ten) years</strong>{" "}
            from the last date of Services availed or inactivity (whichever is
            later) if You have availed any of the Services on the Application.
          </li>
        </ul>

        <p>
          <strong style={{fontWeight:"bold"}}>5.3.</strong> The Profile Data retained by Us will be subject
          to Your right to withdraw or deny Your consents as per the terms of
          this Privacy Policy and the retention requirements under applicable
          laws. Please note that certain Profile Data (such as Your mobile
          number and email address required for account creation) is mandatory
          for maintaining an account with Us and availing any of the Services on
          the Application. Accordingly, any request to delete such Information
          will be processed only after the closure of all Services availed by
          You and deletion of Your account on the Platform.
        </p>
        <h3 className={classes.heading}>OTHER TERMS</h3>

        <p>
          Terms as set out in <strong style={{fontWeight:"bold"}}>Part E</strong> of this Privacy Policy
          shall apply
          <em>mutatis mutandis</em> to this Part A, to the extent applicable to
          the Profile Data in relation to Your account.
        </p>

        <h2 className={classes.title}>PART B: DIGITAL LENDING SERVICES</h2>

        <h3 className={classes.heading}>
          COLLECTION OF INFORMATION FOR PROVISION OF DIGITAL LENDING SERVICES (
          <strong style={{fontWeight:"bold"}}>&quot;DL DATA&quot;</strong>)
        </h3>

        <p>
          We only facilitate collection of the DL Data below via the Platform.
          We do not store any such DL Data collected via the Platform (other
          than Profile Data as detailed in Part A of this Privacy Policy).
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.1.</strong> All DL Data collected on the Platform for
          provision of Digital Lending Services is done through the following
          means:
        </p>

        <ul>
          <li>
            <strong style={{fontWeight:"bold"}}>i.</strong> Profile Data provided by You as per Part A of
            this Privacy Policy;
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>ii.</strong> Data provided during communications with Us
            (for example, by e-mail or chat) in relation to any Digital Lending
            Services;
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>iii.</strong> Data, consents and Information that You
            provide when You subscribe to any Digital Lending Services (such as
            applying for a loan), search for a loan product, and when You report
            a problem with any of our Digital Lending Services;
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>iv.</strong> Data received by Us from third parties based on
            consents given by You under this Part B of the Privacy Policy; and
          </li>

          <li>
            <strong style={{fontWeight:"bold"}}>v.</strong> Data generated by Your usage of our Platform
            while availing Digital Lending Services. The entire collection of DL
            Data is further detailed below.
          </li>
        </ul>

        <p>
          <strong style={{fontWeight:"bold"}}>1.2.</strong> Information collected by the Application from
          You.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.2.1.</strong> The collection of DL Data on the Platform in
          accordance with this Part B of the Privacy Policy is done for
          facilitating Digital Lending Services being provided in the capacity
          of a<strong style={{fontWeight:"bold"}}> &quot;lending services provider&quot;</strong> (LSP) or
          <strong style={{fontWeight:"bold"}}> &quot;digital lending application&quot;</strong> (DLA) (both
          terms as defined under the DLD) of the regulated entities who are
          registered with the RBI and whose details are available on the
          Website, the Application and application stores (such as Google Play
          Store and Apple App Store) (
          <strong style={{fontWeight:"bold"}}>&quot;Lending Partners&quot;</strong>). Please refer to
          Annexure I for the list of active Lending Partners on the Platform,
          along with their respective privacy policies and Terms &amp;
          Conditions.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.2.2.</strong> The entire collection, processing and storage
          (to the extent permitted under applicable laws) of DL Data is done on
          a standalone basis, in accordance with this Part B of the Privacy
          Policy and is not accessible for any of the other Services set out in
          other Parts of this Privacy Policy.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.2.3.</strong> GetCred&apos;s role with respect to Digital
          Lending Services is limited to facilitating access to DL Data
          pertaining to or provided by You on the Platform to our Lending
          Partners in a secure manner and ensuring that all recipients of Your
          personal Information comply with data protection, confidentiality,
          fidelity and secrecy obligations and duly execute covenants in this
          regard.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.2.4.</strong> We have indicated in this Part B the mandatory
          and optional fields of Information required from You. You always have
          the option not to provide any Information by choosing not to use a
          particular service or feature on the Platform. While You can browse
          some sections of our Platform without being a registered member,
          certain activities (such as availing loans from the Lending Partners
          on the Platform) require registration and the provision of mandatory
          Information.
        </p>

        <p>
          <strong style={{fontWeight:"bold"}}>1.2.5.</strong> The personal Information collected by our
          Lending Partners via the Application, its purpose (summarised below
          and as further detailed in Paragraph 2 of this Part B of the Privacy
          Policy), and whether the DL Data to be provided by the User is
          mandatory or optional, is listed below:
        </p>

        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>S. No.</strong>
                </TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>Data Category</strong>
                </TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>Purpose</strong>
                </TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell colSpan={4}>
                  <strong style={{fontWeight:"bold"}}>General</strong>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>Personal and Demographic Information</strong>
                  <br />
                  Mobile, Email, Name, Gender, DOB, Address, Postal Code, PAN.
                </TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>
                    Account Creation, Identity Verification, Customer KYC, Fraud
                    Prevention, Underwriting, Enabling Communication and
                    Customer Support, Legal Compliance, Advertisement and
                    Marketing
                  </strong>
                  <br />
                  <br />
                  This Information is used for identifying You, preventing
                  unauthorised access and providing the Digital Lending Services
                  to uniquely identify, register and enable You to use the
                  Website. This Information is also used for underwriting to
                  determine Your eligibility for loan products.
                </TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>Asset Information</TableCell>
                <TableCell>
                  Underwriting and assessing financial repayment capability.
                </TableCell>
                <TableCell>Optional</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>3</TableCell>
                <TableCell>PAN and Credit Information from Bureaus</TableCell>
                <TableCell>Underwriting, Legal Compliance.</TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>4</TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                  <br />
                  Device hardware Information or other IDs such as log
                  Information (IP address, search queries, crashes, date, etc.),
                  device Information when You download and install the
                  Application. Collection depends on Your privacy settings.
                </TableCell>
                <TableCell>
                  Log Information is collected for improving Platform
                  functionality, Identity Verification and Fraud Prevention.
                  Performance and diagnostic Information is used to identify and
                  resolve technical issues and improve overall Website
                  functionality.
                </TableCell>
                <TableCell>
                  Mandatory if applied through the Applications on iOS or
                  Android.
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>5</TableCell>
                <TableCell>KYC Information</TableCell>
                <TableCell>
                  Identity Verification, Fraud Prevention and Legal Compliance.
                </TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>6</TableCell>
                <TableCell>Geolocation and IP Information</TableCell>
                <TableCell>
                    GetCred seeks permission for location to collect and monitor the information about the location of customer’s device to provide serviceability of loan application, to reduce risk associated with the loan
                    application and to provide pre-approved customised loan offers. This also helps us to
                    facilitate verification of the address, making a better credit risk decision and know your
                    customer (KYC) process;
                </TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>7</TableCell>
                <TableCell>
                  Reference Information including name, number and address of
                  References voluntarily provided to the Lending Partners.
                </TableCell>
                <TableCell>
                  Identity Verification, Fraud Prevention and Loan Collection.
                </TableCell>
                <TableCell>
                  Mandatory on Android Application and Website.
                  <br />
                  Optional on iOS Application.
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>8</TableCell>
                <TableCell>
                  <strong style={{fontWeight:"bold"}}>SMS and Installed Apps Information</strong>
                  <br />
                  We collect, store and monitor SMS Information. Metadata of
                  installed applications includes application name, package
                  name, install/update time, version name and version code. This
                  Information may be collected even when the Application is
                  closed.
                </TableCell>
                <TableCell>
                  Used to provide updates and confirmations during Digital
                  Lending Services, customised offers, Identity Verification,
                  Fraud Prevention and Underwriting.
                </TableCell>
                <TableCell>
                  Mandatory on Android Application.
                  <br />
                  Optional for Website and iOS Application.
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>9</TableCell>
                <TableCell>Transaction Information</TableCell>
                <TableCell>
                  For enabling the App and its Services, Legal Compliance.
                </TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>10</TableCell>
                <TableCell>Usage Information</TableCell>
                <TableCell>
                  For enabling and enhancing the Digital Lending Services.
                </TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>11</TableCell>
                <TableCell>Feedback and Similar Information</TableCell>
                <TableCell>For enabling the App and its Services.</TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>12</TableCell>
                <TableCell>
                  Risk Evaluation Score received from Payment Gateway Providers.
                </TableCell>
                <TableCell>Underwriting.</TableCell>
                <TableCell>Mandatory</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </section>
      <h2 className={classes.title}>PART C: GetCred UPI SERVICES</h2>
      <h3 className={classes.heading}>
        COLLECTION OF INFORMATION FOR PROVISION OF UPI SERVICE ON THE
        APPLICATION (<strong style={{fontWeight:"bold"}}>&quot;UPI SERVICE DATA&quot;</strong>)
      </h3>
      <p>
        <strong style={{fontWeight:"bold"}}>1.1.</strong> All UPI Service Data collected on the Platform for
        the provision of UPI services on the Platform (
        <strong style={{fontWeight:"bold"}}>&quot;GetCred UPI Services&quot;</strong>) is collected
        through the following means:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>i.</strong> Profile Data provided by You as per Part A of this
          Privacy Policy.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>ii.</strong> Data provided during communications with Us (for
          example, by e-mail or chat) in relation to the GetCred UPI Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>iii.</strong> Data, consents and Information that You provide
          when You avail the GetCred UPI Services, and when You report a
          problem with the GetCred UPI Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>iv.</strong> Data received by Us from third parties based on
          consents given by You under this Part C of the Privacy Policy.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>v.</strong> Data generated by Your usage of our Platform while
          availing the GetCred UPI Services. The entire collection of UPI
          Service Data is further detailed below.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.</strong> Information collected by the Application from You.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.1.</strong> The collection of UPI Service Data in accordance
        with this Part C of the Privacy Policy is carried out for facilitating
        the GetCred UPI Services on the Platform in partnership with multiple
        Payment Service Provider banks (<strong style={{fontWeight:"bold"}}>&quot;PSP&quot;</strong>) and
        the
        <strong style={{fontWeight:"bold"}}> &quot;National Payments Corporation of India&quot;</strong> (
        <strong style={{fontWeight:"bold"}}>&quot;NPCI&quot;</strong>) for the movement of funds between the
        sender&apos;s and receiver&apos;s bank accounts.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.2.</strong> The entire collection, processing and storage of
        UPI Service Data is carried out on a standalone basis in accordance with
        this Part C of the Privacy Policy and is not accessible for any of the
        other Services covered under the remaining Parts of this Privacy Policy.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.3.</strong> GetCred&apos;s role with respect to the
        GetCred UPI Services is limited to facilitating secure access to the
        UPI Service Data pertaining to or provided by You on the Platform to the
        PSPs and NPCI, and to ensuring that all recipients of Your personal
        Information comply with applicable data protection, confidentiality,
        fidelity and secrecy obligations and execute appropriate contractual
        covenants.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.4.</strong> In addition to Your mobile number and email ID
        (forming part of the Profile Data) collected for creating Your account,
        we also collect, store, process and share the following personal
        Information for facilitating the GetCred UPI Services.
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Data Category</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Information</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Bank Account Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Masked Debit Card Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>Masked Aadhaar Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>Contact Information</TableCell>
              <TableCell>
                Provision of GetCred UPI Services, Identity Verification and
                Fraud Prevention.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                <br />
                Device hardware Information or other identifiers such as log
                Information (via the domain server through which the User
                accesses the Application), including search queries, IP address,
                crashes, date, device Information and similar technical
                Information.
              </TableCell>
              <TableCell>Identity Verification and Fraud Prevention.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>Transaction Information</TableCell>
              <TableCell>
                For enabling the Application and GetCred UPI Services, and for
                Legal Compliance.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>Feedback and Similar Information</TableCell>
              <TableCell>
                For enabling the Application and its Services.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Data Category</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Information</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Bank Account Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Masked Debit Card Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>Masked Aadhaar Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>Contact Information</TableCell>
              <TableCell>
                Provision of GetCred UPI Services, Identity Verification and
                Fraud Prevention.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                <br />
                Device hardware Information or other identifiers such as log
                Information (search queries, IP address, crashes, date, etc.)
                and device Information.
              </TableCell>
              <TableCell>Identity Verification and Fraud Prevention.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>Transaction Information</TableCell>
              <TableCell>
                For enabling the Application and GetCred UPI Services, and for
                Legal Compliance.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>Feedback and Similar Information</TableCell>
              <TableCell>
                For enabling the Application and its Services.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Consents</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>8</TableCell>
              <TableCell>
                Your consent to use the Platform and avail GetCred UPI
                Services in accordance with this Privacy Policy, the Security
                Guidelines (displayed during registration), and the UPI Terms
                &amp; Conditions available on the Website.
              </TableCell>
              <TableCell>
                For enabling the Application and availing GetCred UPI
                Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>9</TableCell>
              <TableCell>Consent to read and send SMS Information.</TableCell>
              <TableCell>
                Identity Verification and Fraud Prevention.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>10</TableCell>
              <TableCell>Consent to read phone state.</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>11</TableCell>
              <TableCell>Consent to monitor UPI usage.</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>12</TableCell>
              <TableCell>
                Consent to access Your camera (to share photos of necessary
                documents).
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>13</TableCell>
              <TableCell>Consent for UPI usage.</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>14</TableCell>
              <TableCell>
                Consent for linking Your mobile number to receive money.
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>15</TableCell>
              <TableCell>UPI Lite Enablement Consent.</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>16</TableCell>
              <TableCell>UPI International Activation Consent.</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>17</TableCell>
              <TableCell>
                UPI International Transaction Charges Consent.
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>18</TableCell>
              <TableCell>Consent for sharing Your Aadhaar details.</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>19</TableCell>
              <TableCell>
                Consent for adding a payment instrument for GetCred UPI
                Services.
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.5.</strong> We have indicated in this Part C the mandatory
        and optional fields of Information required from You. You always have
        the option not to provide any Information by choosing not to use a
        particular service or feature on the Platform. While You may browse
        certain sections of the Platform without being a registered member,
        availing the GetCred UPI Services requires registration and the
        provision of the mandatory Information.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.6.</strong> The registration process for availing GetCred
        UPI Services is determined by the National Payments Corporation of India
        (<strong style={{fontWeight:"bold"}}>NPCI</strong>) in accordance with the UPI Guidelines, as
        amended from time to time. The registration process requires access to
        Your mobile network and sending a unique SMS from Your mobile phone to
        verify, validate, register and link Your bank account on the Platform
        and create a unique Virtual Payment Address (
        <strong style={{fontWeight:"bold"}}>&quot;VPA&quot;</strong>). GetCred, acting as a
        <strong style={{fontWeight:"bold"}}> &quot;Third Party Application Provider&quot;</strong> (
        <strong style={{fontWeight:"bold"}}>&quot;TPAP&quot;</strong>), is responsible for implementing the
        registration process as prescribed by NPCI and facilitating UPI-based
        payment transactions on the Platform.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.7.</strong> When You register to use the GetCred UPI
        Services, You provide Your bank&apos;s name and confirm Your bank
        account. If You do not already have a UPI PIN for Your bank account, You
        may create one using Your partial debit card number, expiry date, PIN
        (where required by Your bank), and the one-time password (OTP) issued by
        Your bank.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.8.</strong> While We obtain Your masked bank account
        Information, We do not collect or store the actual bank account number
        linked to Your VPA, or any sensitive personal data such as Your debit
        card number, expiry date, PIN, OTP or UPI PIN. We do not have access to
        the UPI PIN set by You, as it is encrypted.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.9.</strong> When You send, receive or request payments, You
        provide or confirm Information relating to the transaction, including
        the receiver&apos;s name, phone number, GetCred UPI ID (Virtual
        Payment Address), payment amount and currency. Every payment must be
        authorized using Your UPI PIN. We also automatically collect UPI Service
        Data relating to the transaction, including the transaction date, time
        and reference transaction number. Where a sender makes a payment to a
        contact, We collect account and transaction Information, including the
        sender&apos;s and receiver&apos;s names and GetCred UPI IDs. Such
        payment transaction Information is handled securely.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.</strong> Collection of Information from NPCI and PSP Banks.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.1.</strong> We receive financial Information about You and
        Your transactions from the PSP Bank, including Information required to
        confirm Your registration, the payment sender&apos;s or receiver&apos;s
        name, account Information and status, balance sufficiency, transaction
        and account identifiers, risk or fraud alerts and other related
        Information. All such UPI Service Data is stored in encrypted form.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.2.</strong> Please note that the terms, conditions and
        guidelines of the PSP Bank and NPCI governing the provision of the
        GetCred UPI Services shall apply to and govern Your use of such
        services.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.4.</strong> Consents sought as part of rendering the GetCred
        UPI Services (through the Application).
      </p>
      <p>
        Please refer to the table below for the types of Information that may be
        requested from You on the Platform for providing the GetCred UPI
        Services, as disclosed on the application stores (i.e., Google Play
        Store and Apple App Store).
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Data</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Personal Information</strong>
                <ul>
                  <li>Name</li>
                  <li>Email Address</li>
                  <li>Phone Number</li>
                </ul>
              </TableCell>
              <TableCell>
                App Functionality, Account Creation, Identity Verification,
                Customer KYC, Fraud Prevention, Underwriting, Enabling
                Communication and Customer Support, Legal Compliance,
                Advertisement and Marketing.
              </TableCell>
              <TableCell>
                Mobile Number &amp; Email ID – Mandatory (collected as part of
                Profile Data).
                <br />
                Name – Mandatory as returned from UPI registration.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                <ul>
                  <li>Device Hardware Information</li>
                  <li>Log Information</li>
                  <li>Search Queries</li>
                  <li>IP Address</li>
                  <li>Crashes</li>
                  <li>Date &amp; Time</li>
                  <li>Device Information</li>
                </ul>
              </TableCell>
              <TableCell>Identity Verification and Fraud Prevention.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Application Information</strong>
                <ul>
                  <li>Crash Logs</li>
                  <li>Diagnostics</li>
                  <li>Other App Performance Data</li>
                </ul>
              </TableCell>
              <TableCell>
                Information relating to platform performance and diagnostics is
                collected for identifying and resolving technical issues,
                performing data analytics and supporting app functionality.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Photos</strong>
                <br />
                We do not access Your device files other than photos voluntarily
                taken through the camera or uploaded as part of the GetCred
                UPI Services.
              </TableCell>
              <TableCell>
                Camera or photo access is requested to scan, capture or upload
                QR codes for facilitating quick payments and app functionality.
              </TableCell>
              <TableCell>Optional for Part C Services</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Contacts</strong>
                <br />
                No contact Information is shared off the device except the phone
                number of the contact voluntarily selected for making a payment.
              </TableCell>
              <TableCell>
                App functionality and provision of GetCred UPI Services.
              </TableCell>
              <TableCell>Optional for Part C Services</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Other Files and Documents</strong>
                <br />
                We do not access Your device files other than files voluntarily
                uploaded as part of the GetCred UPI Services.
              </TableCell>
              <TableCell>App functionality.</TableCell>
              <TableCell>Optional for Part C Services</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>SMS and Phone State</strong>
                <ul>
                  <li>Permission to send and receive SMS</li>
                  <li>
                    Permission to collect SIM Information (phone number and
                    network provider)
                  </li>
                  <li>
                    No SMS Information is shared outside the device except the
                    UPI registration SMS response used during registration.
                  </li>
                </ul>
              </TableCell>
              <TableCell>
                Used during registration for phone number verification, device
                binding, fraud prevention, security and app functionality.
              </TableCell>
              <TableCell>Mandatory for Part C Services</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <em>
          *The term <strong style={{fontWeight:"bold"}}>app functionality</strong> means the Information
          collected on the Application for providing the GetCred UPI Services
          and improving the overall performance of the Application.
        </em>
      </p>
      <h3 className={classes.heading}>PURPOSE OF COLLECTION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>2.1.</strong> We understand the importance of Your UPI Service
        Data and, as a responsible company, strive to ensure that it is used
        only for the intended purposes described below. The Information
        collected from You is used for facilitating the GetCred UPI Services
        as follows:
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Manner of Use</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>Enabling the Application and the Services</TableCell>
              <TableCell>
                We use the UPI Service Data to enable, operate, provide and
                improve the GetCred UPI Services, protect Users from fraud,
                abuse and other misconduct, and review account activity to
                determine continued compliance with the Terms of Service.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>For Enabling Customer Support</TableCell>
              <TableCell>
                We use Your personal Information (including mobile number and
                email ID forming part of Profile Data) to provide customer
                support, facilitate requests, customize Your experience, enforce
                our terms and conditions, resolve account-related concerns and
                enable communications between You and Us.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Data Analytics</TableCell>
              <TableCell>
                We use Information for analysis and product development to
                improve the UI/UX experience, develop automated actions such as
                fraud detection, and recommend new products and services.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                For Enabling Communications Between You and Us
              </TableCell>
              <TableCell>
                We may communicate with You regarding products, services,
                transaction updates, marketing activities, commercial
                communications, queries and applications submitted through the
                Platform. Information may also be disclosed where required under
                applicable law, court orders or requests from regulatory or law
                enforcement authorities.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>For Legal Compliance and Requirements</TableCell>
              <TableCell>
                We may use Information to investigate claims or disputes,
                prevent fraud, detect illegal activities, conduct forensic
                audits and comply with applicable laws, regulations and official
                requests from Government Agencies.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Advertising, Branding and Marketing</TableCell>
              <TableCell>
                We use Your Information to customize, market and improve the
                GetCred UPI Services, including cross-selling, promotional
                activities, value-added services and other NPCI-approved
                purposes. We may contact You via email, telephone, SMS, WhatsApp
                or other available communication channels regarding these
                activities or any aspect of the GetCred UPI Services.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <h3 className={classes.heading}>STORAGE OF PERSONAL INFORMATION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>3.1.</strong> For facilitating the GetCred UPI Services on the
        Platform, we store the personal Information as set out in Paragraph
        <strong style={{fontWeight:"bold"}}> 1.2.4</strong> of this Part C, together with the Profile Data
        stored in accordance with Part A of this Privacy Policy. We ensure that
        all UPI Service Data collected and retained by Us is stored on servers
        located within India and in compliance with all applicable statutory and
        regulatory obligations.
      </p>
      <h3 className={classes.heading}>DISCLOSURE TO THIRD PARTIES</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>4.1.</strong> We may share Your Information with the following
        categories of third parties for the purposes described below:
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Party Type</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose of Disclosure</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Payment Senders and Recipients</TableCell>
              <TableCell>
                You and the people with whom You send or receive payments may
                store or re-share Your UPI ID, name or transaction Information
                with others, either on or outside the Payments platform.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Governmental or Regulatory Authority</TableCell>
              <TableCell>
                If any Governmental Agency or law enforcement authority requests
                Information and We believe disclosure is required to comply with
                applicable laws, regulations or legal processes, We, the PSP or
                our service partners may disclose the required Information.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>Service Partners</TableCell>
              <TableCell>
                We work with service providers to facilitate GetCred UPI
                Services. Information may be shared to send payment instructions
                to PSP Banks, maintain transaction history, provide customer
                support, improve, customize, secure and market GetCred UPI
                Services, and detect, prevent or investigate fraud, abuse,
                security incidents and other misconduct. Such service providers
                are contractually required to use Your Information only in
                accordance with Our instructions and applicable law.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>PSP Banks and NPCI</TableCell>
              <TableCell>
                We share Information with PSP Banks and the National Payments
                Corporation of India (NPCI) to operate GetCred UPI Services.
                This includes account Information for authentication,
                transaction details, payment amount, UPI IDs, country,
                transaction identifiers, fraud and security alerts and customer
                support Information. Your use of PSP Bank and NPCI services is
                governed by their respective terms and privacy policies.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <h3 className={classes.heading}>DATA RETENTION AND DELETION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>5.1.</strong> We retain Your UPI Service Data to provide a
        seamless experience, contact You when support is required, manage Your
        account, and detect, mitigate, prevent and investigate fraudulent or
        illegal activities during the course of the GetCred UPI Services.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>5.2.</strong> We retain the UPI Service Data from the date of
        provision of such Information:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>(a)</strong> For a period of <strong style={{fontWeight:"bold"}}>6 (six) years</strong>{" "}
          from the last date of submission of Information or inactivity
          (whichever is later), where the User has registered on the Application
          but has not availed any GetCred UPI Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>(b)</strong> For a period of <strong style={{fontWeight:"bold"}}>10 (ten) years</strong>{" "}
          from the last date on which GetCred UPI Services were availed, or
          the Users inactivity (whichever is later), where the User has availed
          any GetCred UPI Services on the Application.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>5.3.</strong> The Profile Data retained by Us shall remain
        subject to Your right to withdraw or deny consent in accordance with
        this Privacy Policy and applicable retention requirements. Please note
        that certain Profile Data, including Your mobile number and email
        address required for account creation, is mandatory for maintaining an
        account and availing the Services. Accordingly, any request to delete
        such Information will be processed only after all Services availed by
        You have been closed and Your account has been deleted from the
        Platform.
      </p>
      <h3 className={classes.heading}>OTHER TERMS</h3>
      <p>
        The terms set out in <strong style={{fontWeight:"bold"}}>Part E</strong> of this Privacy Policy
        shall apply <em>mutatis mutandis</em> to this Part C to the extent
        applicable to UPI Service Data collected for facilitating the GetCred
        UPI Services.
      </p>
      <h2 className={classes.title}>PART C: GetCred UPI SERVICES</h2>
      <h3 className={classes.heading}>
        COLLECTION OF INFORMATION FOR PROVISION OF UPI SERVICE ON THE
        APPLICATION (<strong style={{fontWeight:"bold"}}>&quot;UPI SERVICE DATA&quot;</strong>)
      </h3>
      <p>
        <strong style={{fontWeight:"bold"}}>1.1.</strong> All UPI Service Data collected on the Platform for
        the provision of UPI services (
        <strong style={{fontWeight:"bold"}}>&quot;GetCred UPI Services&quot;</strong>) is collected
        through the following means:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>i.</strong> Profile Data provided by You as per
          <strong style={{fontWeight:"bold"}}> Part A</strong> of this Privacy Policy.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>ii.</strong> Data provided during communications with Us (for
          example, by email or chat) in relation to the GetCred UPI Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>iii.</strong> Data, consents and Information that You provide
          when You avail the GetCred UPI Services and when You report any
          issue relating to the GetCred UPI Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>iv.</strong> Data received by Us from third parties based on
          the consents provided by You under this Part C of the Privacy Policy.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>v.</strong> Data generated by Your use of the Platform while
          availing the GetCred UPI Services. The complete collection of UPI
          Service Data is further detailed below.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.</strong> Information collected by the Application from You.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.1.</strong> The collection of UPI Service Data in accordance
        with this Part C of the Privacy Policy is carried out for facilitating
        the GetCred UPI Services on the Platform in partnership with multiple
        Payment Service Provider Banks (<strong style={{fontWeight:"bold"}}>&quot;PSP&quot;</strong>) and
        the National Payments Corporation of India (
        <strong style={{fontWeight:"bold"}}>&quot;NPCI&quot;</strong>) for facilitating the movement of
        funds between the sender&apos;s and receiver&apos;s bank accounts.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.2.</strong> The collection, processing and storage of UPI
        Service Data is carried out on a standalone basis in accordance with
        this Part C of the Privacy Policy and is not accessible for any of the
        other Services covered under the remaining Parts of this Privacy Policy.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.3.</strong> GetCred&apos;s role with respect to the
        GetCred UPI Services is limited to securely facilitating access to the
        UPI Service Data pertaining to or provided by You on the Platform to the
        PSP Banks and NPCI, while ensuring that all recipients of Your personal
        Information comply with applicable obligations relating to data
        protection, confidentiality, fidelity and secrecy and execute
        appropriate contractual covenants.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.4.</strong> In addition to Your mobile number and email ID
        (forming part of the Profile Data) collected for creating Your account,
        We also collect, store, process and share the following personal
        Information for facilitating the GetCred UPI Services.
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Data Category</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Information</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Bank Account Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Masked Debit Card Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>Masked Aadhaar Information</TableCell>
              <TableCell>Provision of GetCred UPI Services.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>Contact Information</TableCell>
              <TableCell>
                Provision of GetCred UPI Services, Identity Verification and
                Fraud Prevention.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                <br />
                Device hardware Information and other identifiers including log
                Information (search queries, IP address, crashes, date, etc.)
                and device Information.
              </TableCell>
              <TableCell>Identity Verification and Fraud Prevention.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>Transaction Information</TableCell>
              <TableCell>
                For enabling the Application and GetCred UPI Services, and for
                Legal Compliance.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>Feedback and Similar Information</TableCell>
              <TableCell>
                For enabling the Application and its Services.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Consents</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>8</TableCell>
              <TableCell>
                Consent to use the Platform and avail GetCred UPI Services in
                accordance with this Privacy Policy, the Security Guidelines
                (displayed during registration), and the UPI Terms &amp;
                Conditions available on the Website.
              </TableCell>
              <TableCell>
                For enabling the Application and availing GetCred UPI
                Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>9</TableCell>
              <TableCell>Consent to Read and Send SMS Information</TableCell>
              <TableCell>
                Identity Verification and Fraud Prevention.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>10</TableCell>
              <TableCell>Consent to Read Phone State</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>11</TableCell>
              <TableCell>Consent to Monitor UPI Usage</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>12</TableCell>
              <TableCell>
                Consent to Access Your Camera (to share photos of necessary
                documents)
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>13</TableCell>
              <TableCell>Consent for UPI Usage</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>14</TableCell>
              <TableCell>
                Consent for Linking Your Mobile Number to Receive Money
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>15</TableCell>
              <TableCell>UPI Lite Enablement Consent</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>16</TableCell>
              <TableCell>UPI International Activation Consent</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>17</TableCell>
              <TableCell>
                UPI International Transaction Charges Consent
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>18</TableCell>
              <TableCell>Consent for Sharing Your Aadhaar Details</TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>19</TableCell>
              <TableCell>
                Consent for Adding Payment Instrument for GetCred UPI Services
              </TableCell>
              <TableCell>
                Provision of GetCred UPI Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.5.</strong> We have indicated in this Part C the mandatory
        and optional fields of Information required from You. You always have
        the option not to provide any Information by choosing not to use a
        particular service or feature on the Platform. While You may browse
        certain sections of the Platform without being a registered member,
        availing the GetCred UPI Services requires registration and the
        provision of the mandatory Information.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.6.</strong> The registration process for availing the
        GetCred UPI Services is determined by the National Payments
        Corporation of India (<strong style={{fontWeight:"bold"}}>&quot;NPCI&quot;</strong>) in accordance
        with the UPI Guidelines, as amended from time to time. The registration
        process requires access to Your mobile network and the sending of a
        unique SMS from Your mobile phone to verify, validate, register and link
        Your bank account on the Platform and create a unique Virtual Payment
        Address (<strong style={{fontWeight:"bold"}}>&quot;VPA&quot;</strong>). GetCred, acting in the
        capacity of a
        <strong style={{fontWeight:"bold"}}>&quot;Third Party Application Provider&quot;</strong> (
        <strong style={{fontWeight:"bold"}}>&quot;TPAP&quot;</strong>), is responsible for implementing this
        process as prescribed by NPCI from time to time and facilitating
        UPI-based payment transactions on the Platform.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.7.</strong> When You register to use the GetCred UPI
        Services, You provide Your bank&apos;s name and confirm Your bank
        account. If You do not already have a UPI PIN for Your bank account, You
        may create one using Your partial debit card number, expiry date, PIN
        (where required by Your bank) and the one-time password (
        <strong style={{fontWeight:"bold"}}>OTP</strong>) issued by Your bank to set up the UPI PIN.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.8.</strong> While We obtain Your masked bank account
        Information, We do not collect or store the actual bank account number
        linked to Your
        <strong style={{fontWeight:"bold"}}>VPA</strong>, nor do We store sensitive personal data such as
        Your debit card number, expiry date, PIN, OTP or UPI PIN. We do not have
        access to the UPI PIN set by You, as it is encrypted.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.9.</strong> When You send, receive or request payments, You
        provide or confirm Information relating to the transaction, including
        the receiver&apos;s name, phone number, GetCred UPI ID (Virtual
        Payment Address), payment amount and currency. Every payment must be
        authorized using Your UPI PIN. We also automatically collect UPI Service
        Data relating to the transaction, including the transaction date, time
        and reference transaction number. Where a sender makes a payment to a
        contact, We collect account and transaction Information, including the
        sender&apos;s and receiver&apos;s names and GetCred UPI IDs. Such
        payment transaction Information is handled securely.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.</strong> Collection of Information from NPCI and PSP Banks.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.1.</strong> We receive financial Information about You and
        Your transactions from the Payment Service Provider (
        <strong style={{fontWeight:"bold"}}>PSP</strong>) Bank, including Information required to confirm
        Your registration, the payment sender&apos;s or receiver&apos;s name,
        account Information and status, balance sufficiency, transaction and
        account identifiers, and risk or fraud alerts. All such UPI Service Data
        is stored in encrypted form.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.2.</strong> Please note that the terms, conditions and
        guidelines of the PSP Bank and the National Payments Corporation of
        India (<strong style={{fontWeight:"bold"}}>NPCI</strong>) governing the provision of the GetCred
        UPI Services shall apply to and govern Your use of such services.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.4.</strong> Consents sought as part of rendering the GetCred
        UPI Services (through the Application).
      </p>
      <p>
        Please refer to the table below for the types of Information that may be
        requested from You on the Platform for providing the GetCred UPI
        Services, as disclosed on the application stores (i.e., Google Play
        Store and Apple App Store).
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Data</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Personal Information</strong>
                <ul>
                  <li>Name</li>
                  <li>Email Address</li>
                  <li>Phone Number</li>
                </ul>
              </TableCell>
              <TableCell>
                App Functionality, Account Creation, Identity Verification,
                Customer KYC, Fraud Prevention, Underwriting, Enabling
                Communication and Customer Support, Legal Compliance,
                Advertisement and Marketing.
              </TableCell>
              <TableCell>
                Mobile Number &amp; Email ID – Mandatory (collected as part of
                Profile Data).
                <br />
                Name – Mandatory as returned from UPI registration.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                <ul>
                  <li>Device Hardware Information</li>
                  <li>Log Information</li>
                  <li>Search Queries</li>
                  <li>IP Address</li>
                  <li>Crashes</li>
                  <li>Date, etc.</li>
                  <li>Device Information</li>
                </ul>
              </TableCell>
              <TableCell>Identity Verification and Fraud Prevention.</TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Application Information</strong>
                <ul>
                  <li>Crash Logs</li>
                  <li>Diagnostics</li>
                  <li>Other App Performance Data</li>
                </ul>
              </TableCell>
              <TableCell>
                Information related to the performance of the Platform and other
                diagnostic data is collected for identifying and resolving
                technical issues, performing data analytics and supporting app
                functionality.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Photos</strong>
                <br />
                We do not facilitate access to Your device files other than
                photos voluntarily taken through the camera or uploaded as part
                of the GetCred UPI Services.
              </TableCell>
              <TableCell>
                Camera or Photos access is requested to scan, capture or upload
                QR codes for facilitating quick payments and app functionality.
              </TableCell>
              <TableCell>Optional for Part C Services</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Contacts</strong>
                <br />
                No contact Information is shared outside the device except the
                phone number of the voluntarily selected contact to whom a
                payment is made.
              </TableCell>
              <TableCell>
                App functionality and provision of GetCred UPI Services.
              </TableCell>
              <TableCell>Optional for Part C Services</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Other Files and Documents</strong>
                <br />
                We do not facilitate access to Your device files other than
                files that You voluntarily upload as part of the GetCred UPI
                Services.
              </TableCell>
              <TableCell>App functionality.</TableCell>
              <TableCell>Optional for Part C Services</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>SMS and Phone State</strong>
                <ul>
                  <li>Permission to send and receive SMS.</li>
                  <li>
                    Permission to collect SIM Information (phone number and
                    network provider).
                  </li>
                  <li>
                    No SMS Information is shared outside the device except the
                    UPI registration SMS response received during the
                    registration process.
                  </li>
                </ul>
              </TableCell>
              <TableCell>
                Used during registration for phone number verification, device
                binding, fraud prevention, app functionality and security.
              </TableCell>
              <TableCell>Mandatory for Part C Services</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <em>
          *The term <strong style={{fontWeight:"bold"}}>app functionality</strong> means the Information
          collected on the Application for providing the GetCred UPI Services
          and improving the overall performance of the Application.
        </em>
      </p>
      <h3 className={classes.heading}>PURPOSE OF COLLECTION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>2.1.</strong> We understand the importance of Your UPI Service
        Data and, as a responsible company, strive to ensure that it is used
        only for the intended purposes described below. We shall use the
        Information collected from You for facilitating the GetCred UPI
        Services for the following purposes:
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Manner of Use</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>Enabling the Application and the Services</TableCell>
              <TableCell>
                We use the UPI Service Data to enable, operate, provide and
                improve the GetCred UPI Services; protect You and other Users
                from fraud, abuse or other misconduct; and review Your account
                activity to determine whether You continue to comply with our
                Terms of Service.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>For Enabling Customer Support</TableCell>
              <TableCell>
                We use Your personal Information (including the mobile number
                and email ID forming part of Your Profile Data) to provide
                customer support, facilitate requests, customize Your
                experience, enforce our terms and conditions, resolve
                account-related concerns and enable communications between You
                and Us through the Platform or other channels.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Data Analytics</TableCell>
              <TableCell>
                We use the Information collected for analysis and product
                development to improve the UI/UX experience, develop automated
                actions such as fraud detection and recommend new products and
                services.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                For Enabling Communications Between You and Us
              </TableCell>
              <TableCell>
                We may communicate with You regarding products, services,
                notifications, transactions, applications submitted through the
                Platform, promotional activities and commercial communications.
                We may also disclose Information where required under applicable
                laws, court orders or requests from regulatory or law
                enforcement authorities.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>For Legal Compliance and Requirements</TableCell>
              <TableCell>
                We may use the Information collected to investigate or address
                claims or disputes relating to GetCred UPI Services, prevent
                fraud, detect illegal activities, conduct forensic audits and
                comply with applicable laws, regulations and requests from
                Government Agencies or other regulatory authorities.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Advertising, Branding and Marketing</TableCell>
              <TableCell>
                We use Your Information to customize, market and improve
                GetCred UPI Services, including cross-selling, advertising,
                promotions, value-added services and other purposes approved by
                NPCI. We may contact You through email, telephone, SMS, WhatsApp
                or any other available communication channel regarding these
                activities or any aspect of the GetCred UPI Services availed
                by You.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <h3 className={classes.heading}>STORAGE OF PERSONAL INFORMATION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>3.1.</strong> For facilitating the GetCred UPI Services on the
        Platform, We store the personal Information specified in Paragraph
        <strong style={{fontWeight:"bold"}}>1.2.4</strong> of this Part C, together with the Profile Data
        stored in accordance with Part A of this Privacy Policy. We ensure that
        all UPI Service Data collected and retained by Us is stored on servers
        located within India and maintained in compliance with all applicable
        statutory and regulatory requirements.
      </p>
      <h3 className={classes.heading}>DISCLOSURE TO THIRD PARTIES</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>4.1.</strong> We may share Your Information with the following
        categories of third parties for the purposes described below:
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Party Type</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose of Disclosure</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Payment Senders and Recipients</TableCell>
              <TableCell>
                You and persons with whom You send or receive payments may store
                or re-share Your UPI ID, name or transaction Information with
                others, whether on or outside the Payments platform.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Governmental or Regulatory Authority</TableCell>
              <TableCell>
                If any Governmental Agency or law enforcement authority requests
                or requires Information and We believe disclosure is necessary
                to comply with applicable laws, regulations or legal processes,
                We, the PSP Bank or our service partners may disclose the
                required Information.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>Service Partners</TableCell>
              <TableCell>
                In accordance with our relationship with PSP Banks, We work with
                service providers to facilitate GetCred UPI Services.
                Information may be shared to send payment instructions to PSP
                Banks, maintain transaction history, provide customer support,
                improve, understand, customize, support and market GetCred UPI
                Services, and detect, prevent or investigate fraud, abuse,
                security incidents or other misconduct. Such service providers
                are contractually required to use Your Information only in
                accordance with Our instructions, terms and applicable law.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>PSP Banks and NPCI</TableCell>
              <TableCell>
                We share Information with PSP Banks and the National Payments
                Corporation of India (NPCI) to operate GetCred UPI Services.
                This includes account Information for authentication,
                transaction Information, payment amounts, UPI IDs, country,
                transaction and account identifiers, fraud and security alerts,
                and customer support Information. Your use of PSP Bank and NPCI
                services is governed by their respective terms and privacy
                policies.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <h3 className={classes.heading}>DATA RETENTION AND DELETION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>5.1.</strong> We retain Your UPI Service Data to provide a
        seamless experience, contact You when support is required, manage Your
        account, and detect, mitigate, prevent and investigate fraudulent or
        illegal activities during the course of the GetCred UPI Services.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>5.2.</strong> We retain the UPI Service Data from the date on
        which such Information is provided:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>(a)</strong> For a period of <strong style={{fontWeight:"bold"}}>6 (six) years</strong>{" "}
          from the last date of submission of Information or inactivity
          (whichever is later), where the User has registered on the Application
          but has not availed any GetCred UPI Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>(b)</strong> For a period of <strong style={{fontWeight:"bold"}}>10 (ten) years</strong>{" "}
          from the last date on which GetCred UPI Services were availed, or
          the Users inactivity (whichever is later), where the User has availed
          any Services on the Application.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>5.3.</strong> The Profile Data retained by Us shall remain
        subject to Your right to withdraw or deny consent in accordance with
        this Privacy Policy and applicable retention requirements. Please note
        that certain Profile Data, including Your mobile number and email
        address required for account creation, is mandatory for maintaining an
        account and availing the Services. Accordingly, any request to delete
        such Information will be processed only after all Services availed by
        You have been closed and Your account has been deleted from the
        Platform.
      </p>
      <h3 className={classes.heading}>OTHER TERMS</h3>
      <p>
        The terms set out in <strong style={{fontWeight:"bold"}}>Part E</strong> of this Privacy Policy
        shall apply <em>mutatis mutandis</em> to this Part C, to the extent
        applicable to the UPI Service Data collected for facilitating the
        GetCred UPI Services.
      </p>
      <h2 className={classes.title}>PART D: ADDITIONAL SERVICES</h2>
      <p>
        This Part D stipulates our Privacy Policy in relation to the following
        services (<strong style={{fontWeight:"bold"}}>&quot;Additional Services&quot;</strong>) that are
        made available to You on the Platform:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>(A)</strong> Digital Gold products (including the sale,
          purchase and leasing of digital gold products); and
        </li>
        <li>
          <strong style={{fontWeight:"bold"}}>(B)</strong> Any and all other non-lending related services
          that may be provided on the Platform from time to time.
        </li>
      </ul>
      <h3 className={classes.heading}>
        COLLECTION OF INFORMATION FOR PROVISION OF ADDITIONAL SERVICES (
        <strong style={{fontWeight:"bold"}}>&quot;NL DATA&quot;</strong>)
      </h3>
      <p>
        <strong style={{fontWeight:"bold"}}>1.1.</strong> All NL Data collected on the Platform for the
        provision of Additional Services is done through the following means:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>i.</strong> Profile Data provided by You as per Part A of this
          Privacy Policy;
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>ii.</strong> Data provided during communications with Us (for
          example, by e-mail or chat) in relation to any Additional Services;
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>iii.</strong> Data, consents and Information that You provide
          when You search for or subscribe to any Additional Service, and when
          You report a problem with any of the Additional Services;
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>iv.</strong> Data received by Us from third parties based on
          consents given by You under this Part D of the Privacy Policy; and
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>v.</strong> Data generated by Your usage of our Platform while
          availing Additional Services. The entire collection of NL Data is
          further detailed below.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.</strong> Information collected by the Application from You.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.1.</strong> The collection of NL Data on the Application in
        accordance with this Part D of the Privacy Policy is carried out for
        facilitating the Additional Services on the Platform in partnership with
        the relevant third-party service providers (
        <strong style={{fontWeight:"bold"}}>&quot;Additional Service Partners&quot;</strong>).
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.2.</strong> The entire collection, processing and storage of
        NL Data is carried out on a standalone basis in accordance with this
        Part D of the Privacy Policy and is not accessible for any of the other
        Services set out in the other Parts of this Privacy Policy.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.3.</strong> GetCred&apos;s role with respect to the
        Additional Services is limited to facilitating secure access to the NL
        Data pertaining to or provided by You on the Platform to our Additional
        Service Partners and ensuring that all recipients of Your personal
        Information comply with data protection, confidentiality, fidelity and
        secrecy obligations and execute the necessary covenants in this regard.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.4.</strong> Collection of personal Information by the
        Application: In addition to Your mobile number and email ID (forming
        part of the Profile Data) collected for creating Your account, we also
        collect, store, process and share the following personal Information for
        facilitating the Additional Services based on the nature of the service
        requested and to provide You with customized support in case of any
        issues. Please note that we do not store any personal Information
        provided by Users for availing the Additional Services except the
        Information specified below.
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Data Category</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose of Collection and Sharing</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Full Name</TableCell>
              <TableCell>
                Enabling Communication and Customer Support, Legal Compliance,
                Identity Verification.
              </TableCell>
              <TableCell>Mandatory if Part D Service is availed.</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Address and Pincode</TableCell>
              <TableCell>Enabling requested Additional Services.</TableCell>
              <TableCell>Mandatory if Part D Service is availed.</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>Date of Birth</TableCell>
              <TableCell>Enabling requested Additional Services.</TableCell>
              <TableCell>Mandatory if Part D Service is availed.</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>Gender</TableCell>
              <TableCell>Enabling requested Additional Services.</TableCell>
              <TableCell>Mandatory if Part D Service is availed.</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>
                Nominee Details
                <br />
                (Name, Gender, Date of Birth and Relationship with User)
              </TableCell>
              <TableCell>
                Nominee selection for requested insurance-related Additional
                Services.
              </TableCell>
              <TableCell>Optional</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.5.</strong> We have indicated in this Part D the mandatory
        and optional fields of Information required from You. You always have
        the option not to provide any Information by choosing not to use a
        particular service or feature on the Platform. While You can browse
        certain sections of our Platform without being a registered member,
        availing the Additional Services requires registration and the provision
        of the mandatory Information.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.2.6.</strong> The personal Information collected and consents
        sought by our Additional Service Partners through the Application, its
        purpose (summarised below and further detailed in Paragraph 2 of this
        Part D of the Privacy Policy), and whether the NL Data to be provided by
        the User is mandatory or optional, are listed below.
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Information Collected from You</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose and Use</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Mandatory / Optional</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Information</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>
                Personal and Demographic Information (as listed in Paragraph
                1.2.4 above)
              </TableCell>
              <TableCell>
                Legal Compliance, Identity Verification, and Enabling
                Communication and Customer Support.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>
                Nominee Details (as listed in Paragraph 1.2.4 above)
              </TableCell>
              <TableCell>
                Provision of insurance-related Additional Services.
              </TableCell>
              <TableCell>Optional</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Device Hardware Details</strong>
                <br />
                Device hardware Information and other identifiers such as log
                Information (IP address, search queries, crashes, date, etc.),
                device Information when You download and install the
                Application. Information collected depends on Your privacy
                controls.
              </TableCell>
              <TableCell>
                Your log Information is collected for improving Platform
                functionality, Identity Verification and Fraud Prevention.
                Performance and diagnostic Information is used for identifying
                and resolving technical issues and improving the overall
                functionality of the Website.
              </TableCell>
              <TableCell>
                Mandatory if accessed through the Website or Applications on
                Android or iOS.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>Transaction Information</TableCell>
              <TableCell>
                For enabling the Application and Additional Services, and for
                Legal Compliance.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>Usage Information</TableCell>
              <TableCell>
                For enabling and enhancing the Additional Services.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>Feedback and Similar Information</TableCell>
              <TableCell>
                For enabling the Application and Additional Services.
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={4}>
                <strong style={{fontWeight:"bold"}}>Consents</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>
                Your consent confirming that You have read the Terms of Use /
                Terms &amp; Conditions and this Privacy Policy of the respective
                Additional Service Partners, and that You consent to using the
                Platform and the collection, processing and sharing of Your NL
                Data by the Additional Service Partners for availing the
                Additional Services in accordance with their policies.
              </TableCell>
              <TableCell>
                For enabling the Application and availing the Additional
                Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Mandatory</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>8</TableCell>
              <TableCell>
                Consent for the Additional Service Partners to send promotional
                communications via SMS, Email and WhatsApp.
              </TableCell>
              <TableCell>
                For availing the Additional Services.
                <br />
                <strong style={{fontWeight:"bold"}}>Consent Type:</strong> Recurring
              </TableCell>
              <TableCell>Optional</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.</strong> Collection of Information from Third Parties.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>1.3.1.</strong> GetCred engages lead generation and customer
        sourcing partners for sourcing, procuring and acquiring Users on the
        Application for availing any of the Additional Services on the Platform
        through offline lead generation or system integration using API
        integration with lead sourcing partners. The nature of personal
        Information provided by such partners to GetCred is limited to the
        Information specified in Paragraph <strong style={{fontWeight:"bold"}}>1.2.4</strong> above.
      </p>
      <h3 className={classes.heading}>PURPOSE OF COLLECTION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>2.1.</strong> We understand the importance of Your Information
        and, as a responsible company, we strive to ensure that it is used only
        for the intended purposes set out below. We shall use the Information
        collected from You for facilitating the Additional Services for the
        following purposes.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.2.</strong> At various stages (i.e., from the moment You
        register on the Application for availing an Additional Service until the
        closure of all products availed by You), the Additional Service Partners
        collect different sets of Information through the Application, as
        mentioned above. The intended purpose of collecting such Information is
        summarized below:
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Manner of Use</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>Enabling the Application and the Services</TableCell>
              <TableCell>
                We use the NL Data to enable the Additional Services on the
                Application and Website, as well as features that help You check
                Your transaction history and other Website features that may be
                introduced from time to time. This also provides us with
                critical usage and feedback Information relating to activity on
                the Application.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>For Enabling Customer Support</TableCell>
              <TableCell>
                We use Your personal Information (including Your mobile number
                and email ID shared as part of the Profile Data) to provide
                customer support, facilitate requests, customize Your
                experience, enforce our Terms and Conditions, and resolve
                concerns relating to Your account. We may also add features that
                enable communication between You and Us, including through the
                Platform or other communication channels.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Data Analytics</TableCell>
              <TableCell>
                We may use the Information collected for analysis and product
                development to improve the UI/UX experience. This helps us
                develop automated actions for events such as fraud detection,
                incorrect IFSC details, and similar scenarios. We may also use
                the Information to offer or recommend new products and services.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                For Enabling Communications Between You and Us
              </TableCell>
              <TableCell>
                We may add features that enable communications between You and
                Us and may access communications, notifications, Information
                regarding the products or services requested by You, process
                queries and applications submitted by You, and communicate
                regarding transactions, promotional activities, marketing and
                commercial communications.
                <br />
                <br />
                We may also disclose Information where required under applicable
                law, court summons, court orders, or requests from legal
                authorities or law enforcement agencies.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>For Legal Compliance and Requirements</TableCell>
              <TableCell>
                We may use the Information collected to investigate or address
                claims or disputes relating to the use of Additional Services,
                prevent fraud, investigate or prevent illegal activities,
                conduct forensic audits, comply with applicable laws, or respond
                to requests from regulators, government entities and official
                authorities.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Advertising, Branding and Marketing</TableCell>
              <TableCell>
                We may use the Information collected to market the Platform.
                This includes sharing Your feedback, ratings and screen names
                for promotional and marketing purposes. We may contact You
                through email, telephone, SMS, WhatsApp, messages or other
                available communication channels regarding marketing activities
                or any matter relating to the Additional Services availed by
                You.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <h3 className={classes.heading}>STORAGE OF PERSONAL INFORMATION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>3.1.</strong> For facilitating the Additional Services on the
        Platform, we store only the personal Information set out in Paragraph
        <strong style={{fontWeight:"bold"}}> 1.2.4</strong> of this Part D, together with the Profile Data
        stored in accordance with Part A of this Privacy Policy. We ensure that
        the Information collected and retained is stored on servers located
        within India and in compliance with all applicable statutory and
        regulatory obligations.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>3.2.</strong> The Additional Service Partners on the Application
        also receive the Information stated above for providing the requested
        Additional Services. Please refer to the privacy policy of the
        respective Additional Service Partner, available on its website, for
        details regarding the manner in which such Information is stored.
      </p>
      <h3 className={classes.heading}>DISCLOSURE TO THIRD PARTIES</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>4.1.</strong> We will share Your Information on a need-to-know
        basis with third parties, including our regulated financial partners,
        vendors and other service providers, for facilitating the Additional
        Services on the Platform.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.2.</strong> We may share Your Information with the following
        categories of third parties for the purposes described below:
      </p>
      <div className={classes.tableWrapper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>S. No.</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Party Type</strong>
              </TableCell>
              <TableCell>
                <strong style={{fontWeight:"bold"}}>Purpose of Disclosure</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Additional Service Partners</TableCell>
              <TableCell>
                For providing the relevant Additional Service offered through
                the Platform.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Governmental or Regulatory Authorities</TableCell>
              <TableCell>
                If any governmental authority or law enforcement agency requests
                Information and we believe disclosure is necessary or
                appropriate to comply with applicable laws, regulations or legal
                processes, we or our Additional Service Partners may disclose
                the required Information.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p>
        <strong style={{fontWeight:"bold"}}>4.3.</strong> We will share Your Information under appropriate
        confidentiality obligations with these third parties and restrict the
        use of such Information solely for the purposes described above.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.4.</strong> We may disclose Your personal Information upon
        receipt of any notice, communication or order as part of Our legal
        obligations under applicable laws, including requests from governmental
        authorities, quasi-governmental authorities, judicial authorities and
        quasi-judicial authorities. By accepting this Privacy Policy, You
        expressly consent to such regulatory disclosure of Your personal
        Information.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.5.</strong> Any disclosure of Information to the above third
        parties shall be subject to the following:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>a.</strong> Where we are under a legal or regulatory
          obligation to disclose or share Your personal Information, we shall
          not be required to seek Your explicit consent or notify You of such
          disclosure.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>b.</strong> We shall obtain Your express consent where
          required before sharing Your personal Information with third parties.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>c.</strong> We shall share Your Information with third parties
          only on a need basis and only for the purposes stated above, in
          accordance with applicable laws.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>d.</strong> We shall seek additional explicit consent at
          appropriate stages of Information collection wherever required under
          applicable laws.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>e.</strong> The use of Your Information by such third parties
          is governed by their respective privacy policies. We share Information
          only to the extent necessary, and We recommend that You review the
          privacy policies of such third parties.
        </li>
      </ul>
      <h3 className={classes.heading}>DATA RETENTION AND DELETION</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>5.1.</strong> We retain the NL Data from the date on which such
        Information is provided:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>(a)</strong> For a period of <strong style={{fontWeight:"bold"}}>6 (six) years</strong>{" "}
          from the last date of submission of Information or inactivity
          (whichever is later) if the User has registered on the Application but
          has not availed any Additional Services.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>(b)</strong> For a period of <strong style={{fontWeight:"bold"}}>10 (ten) years</strong>{" "}
          from the last date on which Additional Services were availed, or from
          the last date of User inactivity (whichever is later), if the User has
          availed any Additional Services on the Application.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>5.2.</strong> The personal Information collected by Us will be
        deleted upon receipt of a reasonable written request from You in the
        manner specified under this Privacy Policy, subject to the retention
        requirements under applicable law. Please note that any request to
        modify or delete Your personal Information, or revoke any consent, will
        be processed only after all ongoing Additional Services and transaction
        accounts have been closed.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>5.3.</strong> With respect to the NL Data collected by the
        Additional Service Partners under this Part D, please refer to the
        respective privacy policy and data retention policy of the relevant
        Additional Service Partners. Any request to modify or delete Information
        collected by the Additional Service Partners must be submitted directly
        to the respective Additional Service Partner for processing in
        accordance with their privacy and data retention policies. You are
        advised to review the privacy policy and data retention policy of the
        Additional Service Partners before availing any Additional Services.
      </p>
      <h3 className={classes.heading}>OTHER TERMS</h3>
      <p>
        The terms set out in <strong style={{fontWeight:"bold"}}>Part E</strong> of this Privacy Policy
        shall apply <em>mutatis mutandis</em> to this Part D, to the extent
        applicable to NL Data collected for facilitating the Additional
        Services.
      </p>
      <h2 className={classes.title}>PART E: MISCELLANEOUS TERMS</h2>
      <p>
        The terms set out below shall apply for any and all Services provided on
        the Platform.
      </p>
      <h3 className={classes.heading}>CHANGES IN THIS PRIVACY POLICY</h3>
      <p>
        We reserve the right to change, modify, add, or remove portions of this
        Privacy Policy at any time for any reason. In the event that any changes
        are made to this Privacy Policy, we shall update the same on the
        Platform. Once posted, those changes shall become effective immediately
        unless stated otherwise. We encourage You to periodically review this
        Privacy Policy for the latest Information regarding our privacy
        practices. Continued access to or use of the Services constitutes Your
        acceptance of the changes to this Privacy Policy.
      </p>
      <h3 className={classes.heading}>SECURITY PRECAUTIONS</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>2.1.</strong> The Platform intends to protect Your Information
        and to maintain its accuracy as confirmed by You. We implement
        reasonable physical, administrative and technical safeguards to help
        protect Your Information from unauthorized access, use and disclosure.
        For example, we encrypt all Information when it is transmitted in
        digital form. We also require our registered third-party service
        providers listed in this Privacy Policy to protect such Information from
        unauthorized access, use and disclosure.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.2.</strong> Our Platform has stringent security measures in
        place to protect against the loss, misuse and alteration of Information
        under our control. We endeavour to safeguard and ensure the security of
        the Information provided by You. We use Secure Sockets Layer (SSL) based
        encryption for the transmission of Information, which is the required
        level of encryption in India under applicable law.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.3.</strong> We comply with all mandatory technology standards
        and cybersecurity requirements stipulated by regulators, agencies, or
        any other applicable authority from time to time for facilitating the
        Services on the Platform.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.4.</strong> We implement security at multiple stages within
        our products using state-of-the-art technology to maintain strong
        security measures and ensure that our data privacy and security design
        protects our systems against both basic and sophisticated attacks.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.5.</strong> In addition, the Website and Application have been
        certified with the following security certifications:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>a. ISO 9001:</strong> The international standard specifying
          requirements for a Quality Management System (QMS). It demonstrates
          the ability to consistently provide products and services that meet
          customer and regulatory requirements while maintaining appropriate
          security protections.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>b. ISO 27001</strong> (formally known as ISO/IEC 27001:2005):
          A specification for an Information Security Management System (ISMS)
          and the suggested certification under the Information Technology Act,
          2000. An ISMS is a framework of policies and procedures that includes
          legal, physical and technical controls for managing information
          security risks.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>2.6.</strong> We aim to protect the Information we hold from
        unauthorized access, alteration, disclosure or destruction through the
        following measures:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>a.</strong> Encryption to keep Your Information private while
          in transit.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>b.</strong> Security features such as OTP verification to help
          You protect Your account.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>c.</strong> Regular review of our Information collection,
          storage and processing practices, including physical security
          measures, to prevent unauthorized access to our systems.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>d.</strong> Restricting access to personal Information to
          employees, representatives, contractors and agents who require it to
          process the Information. Such persons are subject to strict
          contractual confidentiality obligations and appropriate disciplinary
          action for non-compliance.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>e.</strong> Compliance &amp; Cooperation with applicable
          regulations and laws.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>f.</strong> Periodic review of this Privacy Policy to ensure
          that Your Information is processed in accordance with it.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>g.</strong> Compliance with legal frameworks governing the
          transfer of Information under the IT Act, DPDPA and corresponding
          rules, including any amendments.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>h.</strong> Responding to formal written complaints and
          working with the appropriate regulatory authorities, including local
          Information protection authorities, to resolve complaints regarding
          the transfer of Your Information that cannot be resolved directly with
          You.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>2.7.</strong> Data protection laws vary among countries, with
        some providing greater protection than others. We also comply with the
        applicable legal frameworks governing the transfer of Information under
        the Information Technology Act, 2000, its rules and subsequent
        amendments.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.8.</strong> Upon receiving formal written complaints, we
        respond by contacting the person who made the complaint. We work with
        the appropriate regulatory authorities, including local data protection
        authorities, to resolve complaints relating to the transfer of Your
        Information that cannot be resolved directly with You.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.9.</strong> The Website and Application may integrate
        registered third-party SDKs, Application Programming Interfaces (APIs)
        and redirections that collect Information on our behalf. Such
        Information is stored on secure servers. We ensure that these service
        providers implement appropriate security measures, environment
        segregation, segregation of duties and strict role-based, need-to-know
        access controls as required under applicable laws.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.10.</strong> Our third-party service providers employ
        segregation of environments and duties, maintain documented role-based
        access controls and protect stored Information through application-level
        encryption and key management services to limit access.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.11.</strong> Furthermore, our registered third-party service
        providers implement hosting security measures including industry-leading
        anti-virus, anti-malware, intrusion prevention systems, intrusion
        detection systems, file integrity monitoring and application control
        solutions.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>2.12.</strong> The Platform may contain links to other websites
        that collect Information about You. We are not responsible for the
        privacy practices or content of those websites. This Privacy Policy
        applies only to Information collected by Us. Third-party websites may
        have different privacy practices over which We have no control and for
        which We accept no liability.
      </p>
      <h3 className={classes.heading}>CONSENT</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>3.1.</strong> You hereby expressly consent to provide the
        Information that may be required (and for the purposes specified in this
        Privacy Policy) in relation to the creation of Your account,
        registration as a user on the Platform, and general use of the Platform
        in accordance with this Privacy Policy.
      </p>
      <h3 className={classes.heading}>YOUR RIGHTS</h3>
      <p>
        <strong style={{fontWeight:"bold"}}>4.1. Modifying or Rectifying Your Information:</strong> In the
        event that any Profile Data provided by You is inaccurate, incomplete or
        outdated, You shall have the right to provide Us with accurate, complete
        and up-to-date Information and have Us rectify such Information
        immediately. We urge You to ensure that You always provide accurate and
        correct Information so that Your use of Our Services remains
        uninterrupted. In case of any modification of Information, Users may be
        required to furnish supporting documents relating to the change in
        Personal Information for verification by the Company.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.2. Your Privacy Controls:</strong> You have certain choices
        regarding the Information we collect and how it is used:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>a.</strong> Your device may have controls that determine what
          Information we collect. For example, You may modify permissions on
          Your Android, iOS device or browser to remove permissions previously
          granted. However, the Platform does not guarantee the availability of
          Services if such permissions are denied or revoked.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>b.</strong> Delete the Application from Your device.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>c.</strong> You may also request the removal of content from
          our servers in accordance with the applicable provisions of this
          Privacy Policy.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>4.3. Withdrawal / Denial of Consent</strong>
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.3.1.</strong> You acknowledge that the Platform has collected
        Your Profile Data with Your consent. You may choose not to provide
        Information, deny consent for the use of specific Information, restrict
        disclosure to third parties, deny retention of Your Profile Data, revoke
        previously granted consent, or request deletion of such Information.
        However, withdrawal of Profile Data will not be permitted where any
        Service availed by You remains active and such Information is required
        to be retained until completion of the Service.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.3.2.</strong> Where consent has been withdrawn, the Platform
        does not guarantee or accept liability for providing any Services where
        the Information is mandatory for availing such Services. To exercise
        Your right to withdraw or deny consent, please contact us at
        <strong style={{fontWeight:"bold"}}> customercare@aryamanfinance.co.in</strong>.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.3.3.</strong> Any request for withdrawal or denial of consent,
        or deletion of Your Information, will be processed only after all
        ongoing or active Services have been completed or closed. Upon receiving
        a request to update consents or delete Your Profile Data, We will purge
        or delete such Information within <strong style={{fontWeight:"bold"}}>30 (thirty) days</strong> of
        receiving a written request or upon completion of all ongoing Services,
        whichever is later. In the absence of such a request, We will retain
        Your Profile Data in accordance with Paragraph 5.2 of Part A and
        applicable laws. Certain Information may continue to be used for
        completion or termination of outstanding Services.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.3.4.</strong> You shall have the following rights with respect
        to Your Profile Data:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>a. Deny Consent:</strong> You may deny consent for the use of
          specific Information, restrict disclosure to third parties, deny data
          retention, revoke previously granted consent, and request deletion or
          forgetting of Your Information. However, such denial shall not affect
          Our right to retain Information relating to ongoing Services. The
          Platform does not guarantee continued availability of Services where
          mandatory Information is withheld.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>b. Withdraw Consent:</strong> You may withdraw consent for Us
          to contact You, continue collecting, using or disclosing Your Profile
          Data, or request deletion of Your login account by raising a request
          on the Platform or by emailing
          <strong style={{fontWeight:"bold"}}> customercare@aryamanfinance.co.in</strong>. We may continue processing
          Your Profile Data where required for ongoing Services or to comply
          with applicable laws and legal obligations.
        </li>
      </ul>
      <p>
        <strong style={{fontWeight:"bold"}}>4.4. Report an Issue:</strong> You have the right to report any
        security breach or incident to the Grievance Redressal Officer (details
        provided below). You may prevent unauthorized use of Your Information by
        Our personnel, staff or representatives by informing Us immediately, or
        within 10 days of becoming aware of the proposed use, that You do not
        wish to disclose such Information. You may also exercise this right at
        any time by contacting <strong style={{fontWeight:"bold"}}>customercare@aryamanfinance.co.in</strong>.
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>4.5.</strong> Notwithstanding anything stated above, the
        following scenarios may have consequences on Your withdrawal of consent:
      </p>
      <ul>
        <li>
          <strong style={{fontWeight:"bold"}}>a. Marketing and Communication:</strong> Consent for marketing
          and communication is mandatory at the time of account creation and
          registration, but may subsequently be withdrawn by emailing the
          address published on the Platform or by using the Communication
          Opt-Out option available on the Platform.
        </li>

        <li>
          <strong style={{fontWeight:"bold"}}>b. Information Deletion:</strong> Requests for deletion of
          Information may not be implemented while any ongoing Services remain
          active, including Services covered under the relevant Parts of this
          Privacy Policy.
        </li>
      </ul>
      {/* <h3 className={classes.heading}>GRIEVANCE REDRESSAL</h3>
      <p>
        You may make a request for deletion of any Information from the Platform
        at any stage by submitting a request to Us in the following manner:
      </p>
      <h4>Grievance Officer</h4>
      <p>
        For any Information regarding this Privacy Policy, please contact us at{" "}
        <a href="mailto:customercare@aryamanfinance.co.in">customercare@aryamanfinance.co.in</a>.
        In accordance with the Information Technology Act, 2000 and the rules
        made thereunder, the name and contact details of the Grievance Officer
        are provided below for Your reference:
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>Name:</strong> Ms. Asharani
        <br />
        <strong style={{fontWeight:"bold"}}>Address:</strong>
        <br />
        Aryaman Finance (India) Limited,
        <br />
       105, First Floor, Barodia Tower,
        <br />
       rashant Vihar,
        <br />
         Rohini, 
        <br />
        H.A.L II Stage,
        <br />
        Bangalore, Karnataka, India - 560008
        <br />
        <strong style={{fontWeight:"bold"}}>Email:</strong>{" "}
        <a href="mailto:customercare@aryamanfinance.co.in">customercare@aryamanfinance.co.in</a>;{" "}
        <a href="mailto:help@GetCred.in">help@GetCred.in</a>
        <br />
        <strong style={{fontWeight:"bold"}}>Time:</strong> Monday - Saturday (10:00 AM - 7:00 PM)
      </p>
      <p>
        If You do not receive a response from the Grievance Officer within{" "}
        <strong style={{fontWeight:"bold"}}>14 (fourteen) days</strong> of making a representation, or if
        You are not satisfied with the response received, You may contact the
        Nodal Officer using the details below:
      </p>
      <p>
        <strong style={{fontWeight:"bold"}}>Name:</strong> Mr. Abhishek Kumar
        <br />
        <strong style={{fontWeight:"bold"}}>Address:</strong>
        <br />
        Aryaman Finance (India) Limited,
        <br />
       105, First Floor, Barodia Tower,
        <br />
        No. 147,
        <br />
        HAL Old Airport Road,
        <br />
         Rohini, 
        <br />
        Delhi-110085
        <br />
        <strong style={{fontWeight:"bold"}}>Email:</strong>{" "}
        <a href="mailto:customercare@aryamanfinance.co.in">customercare@aryamanfinance.co.in</a>
      </p> */}
    </div>
  );
};

export default PrivacyPolicy;
